<template>
<div id="app" class="gbwapps-page home page-theme page-theme--home">
  <HeadNav selectedLanguage="en" page="gb" :gotodownload="gotodownload" :apk="apk" />

  <main class="gbwapps-main">
    <section class="home-hero">
      <div class="hero-copy">
        <h1>{{ page.hero.title }}</h1>
        <img class="hero-logo" src="@/assets/logo.png" alt="GB WhatsApp" width="96" height="96">
        <p class="hero-subtitle">{{ page.hero.subtitle }}</p>
        <div class="hero-cta">
          <p class="hero-version">{{ page.hero.version }}</p>
          <button class="hero-download" type="button" @click="gotodownload">
            <svg class="hero-download-icon" viewBox="0 0 24 24" aria-hidden="true">
              <path fill="currentColor" d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2v9.67z"/>
            </svg>
            {{ page.hero.downloadLabel }}
          </button>
        </div>
        <ul class="hero-trust">
          <li v-for="item in page.hero.trustBadges" :key="item.label">
            <svg v-if="item.icon === 'star'" class="hero-trust-icon" viewBox="0 0 24 24" aria-hidden="true">
              <path fill="currentColor" d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
            </svg>
            <svg v-else-if="item.icon === 'check'" class="hero-trust-icon" viewBox="0 0 24 24" aria-hidden="true">
              <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
            </svg>
            <svg v-else class="hero-trust-icon" viewBox="0 0 24 24" aria-hidden="true">
              <path fill="currentColor" d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"/>
            </svg>
            {{ item.label }}
          </li>
        </ul>
      </div>
    </section>

    <article class="gbwapps-article">
      <section class="content-section">
        <p v-for="paragraph in page.intro" :key="paragraph">
          <RichText :text="paragraph" />
        </p>
      </section>

      <section class="content-section">
        <h2>GB WhatsApp APK File Details:</h2>
        <div class="table-wrap theme-table details-table">
          <table>
            <tbody>
              <tr
                v-for="(row, index) in page.details"
                :key="row[0]"
                :class="{ 'details-first-row': index === 0 }"
              >
                <th>{{ row[0] }}</th>
                <td><RichText :text="row[1]" /></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section class="content-section">
        <h2>What is GB WhatsApp?</h2>
        <p v-for="paragraph in page.whatIs" :key="paragraph">
          <RichText :text="paragraph" />
        </p>
      </section>

      <section class="content-section feature-band">
        <h2>Features of GB WhatsApp</h2>
        <p>{{ page.featuresIntro }}</p>
        <div class="feature-grid">
          <article v-for="feature in page.features" :key="feature[0]" class="feature-card">
            <h3>{{ feature[0] }}</h3>
            <p><RichText :text="feature[1]" /></p>
          </article>
        </div>
      </section>

      <section class="content-section">
        <h2>System Requirements:</h2>
        <p>{{ page.requirementsIntro }}</p>
        <div class="table-wrap theme-table">
          <table>
            <thead>
              <tr>
                <th v-for="col in page.requirementsHeaders" :key="col">{{ col }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in page.requirements" :key="row[0]">
                <th>{{ row[0] }}</th>
                <td>{{ row[1] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section class="content-section">
        <h2>How to Download GB WhatsApp on Android devices?</h2>
        <p v-for="paragraph in page.downloadIntro" :key="paragraph">{{ paragraph }}</p>
        <ul class="dot-list">
          <li v-for="step in page.downloadSteps" :key="step">
            <RichText :text="step" />
          </li>
        </ul>
      </section>

      <section class="content-section">
        <h2>How to Update GB WhatsApp to the Latest Version?</h2>
        <p v-for="paragraph in page.updateIntro" :key="paragraph">
          <RichText :text="paragraph" />
        </p>
        <p>{{ page.updateIntroLead }}</p>
        <ul class="dot-list">
          <li v-for="step in page.updateSteps" :key="step">
            <RichText :text="step" />
          </li>
        </ul>
      </section>

      <section class="content-section">
        <h2>What's New in the Latest Version of WhatsApp GB?</h2>
        <p v-for="paragraph in page.whatsNewIntro" :key="paragraph">{{ paragraph }}</p>
        <ul class="dot-list">
          <li v-for="item in page.whatsNew" :key="item">{{ item }}</li>
        </ul>
      </section>

      <section class="content-section">
        <h2>How to Backup and Restore Data on GB WhatsApp?</h2>
        <p v-for="paragraph in page.backupIntro" :key="paragraph">
          <RichText :text="paragraph" />
        </p>
        <div v-for="section in page.backupSections" :key="section.heading" class="backup-block">
          <h3>{{ section.heading }}</h3>
          <p v-for="paragraph in (section.paragraphs || [])" :key="paragraph">
            <RichText :text="paragraph" />
          </p>
          <ul v-if="section.list" class="dot-list">
            <li v-for="item in section.list" :key="item">
              <RichText :text="item" />
            </li>
          </ul>
          <p v-if="section.note" class="backup-note">
            <RichText :text="section.note" />
          </p>
          <template v-if="section.subsections">
            <div v-for="sub in section.subsections" :key="sub.heading" class="backup-subsection">
              <h4>{{ sub.heading }}</h4>
              <p v-for="paragraph in (sub.paragraphs || [])" :key="paragraph">
                <RichText :text="paragraph" />
              </p>
              <ul v-if="sub.list" class="dot-list">
                <li v-for="item in sub.list" :key="item">
                  <RichText :text="item" />
                </li>
              </ul>
            </div>
          </template>
        </div>
      </section>

      <section class="content-section">
        <h2>Comparison of GB WhatsApp and Official WhatsApp</h2>
        <p v-for="paragraph in page.comparisonIntro" :key="paragraph">
          <RichText :text="paragraph" />
        </p>
        <div class="table-wrap theme-table comparison-table">
          <table>
            <thead>
              <tr>
                <th v-for="col in page.comparisonHeaders" :key="col">{{ col }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in page.comparisonRows" :key="row[0]">
                <th>{{ row[0] }}</th>
                <td>{{ row[1] }}</td>
                <td>{{ row[2] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section class="content-section">
        <h2>Steps to Fix "You Need Official WhatsApp to Log In" Issue</h2>
        <p v-for="paragraph in page.loginIssueIntro" :key="paragraph">
          <RichText :text="paragraph" />
        </p>
        <div v-for="section in page.loginIssueSections" :key="section.heading">
          <h3>{{ section.heading }}</h3>
          <p v-for="paragraph in (section.paragraphs || [])" :key="paragraph">
            <RichText :text="paragraph" />
          </p>
        </div>
      </section>

      <section class="content-section">
        <h2>How can you Create a GB WhatsApp Channel?</h2>
        <p v-for="paragraph in page.channelIntro" :key="paragraph">
          <RichText :text="paragraph" />
        </p>
        <ul class="dot-list">
          <li v-for="step in page.channelSteps" :key="step">
            <RichText :text="step" />
          </li>
        </ul>
      </section>

      <section class="content-section">
        <h2>How to Migrate from Official WhatsApp to GB WhatsApp APK?</h2>
        <p v-for="paragraph in page.migrationIntro" :key="paragraph">
          <RichText :text="paragraph" />
        </p>
        <ul class="dot-list">
          <li v-for="step in page.migrationSteps" :key="step">
            <RichText :text="step" />
          </li>
        </ul>
      </section>

      <section class="content-section">
        <h2>Device Compatibility of GB WhatsApp APK</h2>
        <p v-for="paragraph in page.compatibilityIntro" :key="paragraph">
          <RichText :text="paragraph" />
        </p>
        <div v-for="section in page.compatibilitySections" :key="section.heading">
          <h3>{{ section.heading }}</h3>
          <p v-for="paragraph in (section.paragraphs || [])" :key="paragraph">
            <RichText :text="paragraph" />
          </p>
        </div>
      </section>

      <section class="content-section alternatives">
        <h2>Alternative Mod WhatsApp to GB WhatsApp</h2>
        <p v-for="paragraph in page.alternativesIntro" :key="paragraph">
          <RichText :text="paragraph" />
        </p>
        <div v-if="page.alternativesImage" class="alternatives-media">
          <img
            class="alternatives-image"
            :src="page.alternativesImage"
            alt="Alternative Mod WhatsApp apps"
            loading="lazy"
          />
          <ul class="dot-list alternatives-list">
            <li v-for="item in page.alternatives" :key="item.label || item">
              <router-link v-if="item.href" :to="item.href">{{ item.label }}</router-link>
              <template v-else>{{ item }}</template>
            </li>
          </ul>
        </div>
      </section>

      <section class="content-section">
        <h2>Conclusion</h2>
        <p v-for="paragraph in page.conclusion" :key="paragraph">
          <RichText :text="paragraph" />
        </p>
      </section>

      <section class="content-section">
        <h2>FAQs</h2>
        <div class="faq-list">
          <div v-for="faq in page.faqs" :key="faq[0]" class="faq-item">
            <h3>{{ faq[0] }}</h3>
            <p><RichText :text="faq[1]" /></p>
          </div>
        </div>
      </section>
    </article>
  </main>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/gbwapps.scss';
import HeadNav from '@/components/HeadNav.vue';
import RichText from '@/components/RichText.vue';
import { homePage } from '@/documents/gbwappsPages';

export default {
  name: 'Home',
  components: {
    HeadNav,
    RichText,
  },
  data() {
    return {
      page: homePage,
      apk: null,
      from: 'gb',
      filename: 'gb',
      selectedLanguage: 'en',
    };
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwapps.net',
          appName: appname || 'GB_gbwapps.net',
        })
        .then((res) => {
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {
      if (this.apk) {
        this.$global.download(this.apk);
      } else {
        this.$router.push({ name: 'en-download' });
      }
    },
  },
};
</script>
